//#region IMPORT
import Commons from '../../../Services/Common/Common';
import Global from '../../../Services/Common/Global';
import { showSnackbar } from '../../../Reducer/SnackbarReducer';
import { apiRequest } from '../../../Services/Common/ApiRequest';
//#endregion

/**
 * 산업안전보건위원회 (SAC_BASIC) 전용 로직
 * other 케이스에서 사용
 */

// 회의사진 가져오기 함수
const SearchPhoto = async (_filePath, imgRef2) => {
  if (!imgRef2) return;
  imgRef2.current = null;

  try {
    if (!_filePath) {
      return;
    }

    imgRef2.current = Global.file.useUrl + 'files/' + _filePath;
  } catch (e) {
    console.log(e);
  } finally {
  }
};

// 서명 파일 변환 함수
function SignFileConvert(_filePath) {
  if (!_filePath) return null;

  const signUrl = `${Global.file.useUrl}files/${_filePath}`;
  let testSign = `data:image/png;base64,${signUrl}`;
  let sign1 = testSign.replace(
    /^data:image\/[a-z]+;base64,/, // 단위작업사진(접두사 없어야 됨)
    ''
  );

  return sign1 || '';
}

// 산업안전보건위원회 인쇄 함수
export const PrintLogic3 = async (
  _gubun,
  _value1, // 년도
  _value2, // 분기
  documentData,
  dispatch,
  setLoading,
  rowData1,
  searchRef,
  imgRef2
) => {
  setLoading(true);

  try {
    // documentData 또는 rowData1[0] 사용
    const selectedItem = documentData || (rowData1 && rowData1[0]);

    if (!selectedItem) {
      dispatch(
        showSnackbar({
          message: '항목을 선택하세요.',
          type: 'warning',
        })
      );
      return null;
    }

    let printData = {};

    // _gubun이 '0'이면 산업보건위원회 규정 레포트
    if (_gubun === '0') {
      printData = { FileName: 'BOBK0100' };
    } else {
      // 회의사진 영역 리셋
      if (imgRef2) {
        imgRef2.current = null;
      }

      let headerData = []; // 헤더 데이터
      let tableData1 = []; // 참석자명단(도급)
      let tableData2 = []; // 회의안건

      // 선택된 회의록 데이터 가져오기
      const selectedMeeting = selectedItem;

      // 회의사진 조회
      if (selectedMeeting.proceedingsImage) {
        try {
          SearchPhoto(selectedMeeting.proceedingsImage, imgRef2);
        } catch (photoError) {
          // 사진 조회 실패해도 인쇄는 계속 진행
          console.error('회의사진 조회 실패:', photoError);
        }
      }

      // 1. headerData 설정 - 회의록 기본정보 (회의사진 포함)
      headerData.push({
        proceedingsTitle: selectedMeeting.proceedingsTitle || '',
        proceedingsDateTime: selectedMeeting.proceedingsDate || '',
        proceedingsLocation: selectedMeeting.proceedingsLocation || '',
        state: selectedMeeting.state || '',
        custNm:
          searchRef.current?.custList?.find((item) => item.value === searchRef.current?.custCd)
            ?.custNm || '',
        year: _value1, // 파라미터로 받은 년도
        quarter: _value2, // 파라미터로 받은 분기
        proceedingsImage: selectedMeeting.proceedingsImage || '', // 회의사진 경로
        proceedingsImageNm: selectedMeeting.proceedingsImageNm || '', // 회의사진 파일명
        meetingPhoto: imgRef2.current
          ? imgRef2.current.replace(
            /^data:image\/[a-z]+;base64,/, // base64 접두사 제거
            ''
          )
          : '', // 회의사진 base64 데이터
      });

      // 2. 참석자명단 데이터 조회 및 설정
      const result1 = await apiRequest(
        'post',
        Global.urls.DocsManagement.getSacBasicR2,
        {
          Chaebun: Commons.EncryptAES(selectedMeeting.chaebun || ''),
        }
      );
      const data = result1.data;

      if (data.length > 0 && data[0]?.type !== 'Error') {
        // GUBUN별로 분리 (회사측: '0', 노동조합측: '1')
        const list0 = data.filter((item) => item.gubun === '0'); // 회사측 참석자
        const list1 = data.filter((item) => item.gubun === '1'); // 노동조합측 참석자

        // 두 리스트 중 길이 큰 값과 최소 7 기준
        const maxLength = Math.max(list0.length, list1.length, 7);

        // 최종 리스트 생성
        for (let i = 0; i < maxLength; i++) {
          tableData1.push({
            // 회사측 참석자 (GUBUN: '0')
            depNm1: list0[i]?.depNm || '',
            name1: list0[i]?.name || '',
            signature1: SignFileConvert(list0[i]?.filePath) || '',
            // 노동조합측 참석자 (GUBUN: '1')
            depNm2: list1[i]?.depNm || '',
            name2: list1[i]?.name || '',
            signature2: SignFileConvert(list1[i]?.filePath) || '',
          });
        }
      }

      // 3. 회의안건 데이터 조회 (데이터베이스에서 최신 데이터 직접 조회)
      const result2 = await apiRequest(
        'post',
        Global.urls.DocsManagement.getSacBasicR3,
        {
          Chaebun: Commons.EncryptAES(selectedMeeting.chaebun || ''),
          SearchText: Commons.EncryptAES('') || '',
        }
      );
      let agendaData = result2.data;

      if (agendaData.length > 0 && agendaData[0]?.type !== 'Error') {
        // 회의안건 데이터 설정 (협의·세부사항)
        const agendaList = agendaData
          .filter((item) => item.agendaName || item.resultDiscussion) // 안건명이나 세부사항이 있는 항목만
          .map((item, index) => ({
            no: index + 1,
            agendaName: item.agendaName || '',
            resultDiscussion: item.resultDiscussion || '',
          }));

        // 9개보다 크면 9개까지만 저장
        if (agendaList.length > 9) {
          agendaList.splice(9);
        }

        tableData2.push(...agendaList);
      } else {
        tableData2.push({ no: '', agendaName: '', resultDiscussion: '' });
      }

      printData = {
        FileName: 'SAC_BASIC',
        HeaderData: JSON.stringify(headerData),
        TableData1: JSON.stringify(tableData1),
        TableData2: JSON.stringify(tableData2),
      };
    }

    const response = await Commons.Axios(
      'report',
      Global.base.useUrl + Global.urls.Reports.reports,
      printData
    );

    return response.data; // Blob 반환
  } catch (e) {
    console.error(e);
    dispatch(
      showSnackbar({
        message: e.message || '인쇄 중 오류가 발생했습니다.',
        type: 'error',
      })
    );
    return null;
  } finally {
    setLoading(false);
  }
};
